/* ============
 * Update client address from brreg
 * ============
 */
import { mapGetters } from 'vuex';
import store from './../../store';
import stringFormatMixin from './../../mixins/stringFormat';

export default {
  data() {
    return {
      // addressType: [],
      addressResult1: [],
      addressResult2: [],
      addressResult3: [],
      thirdPartyAddress: '',
      loading: false,
      addresses: {},
    };
  },
  computed: {
    ...mapGetters({
      currentClientAddresses: 'currentClientAddresses',
    }),

    displayPostalAddress() {
      return this.addresses.postalAddress;
    },

    displayBusinessAddress() {
      return this.addresses.businessAddress;
    },

    displayLocationAddress() {
      return this.addresses.locationAddress;
    },
  },
  methods: {
    update() {
      // const address = this.currentClientAddresses.find(item => item.addressType === this.addressType);
      // const data = address ? Object.assign({}, address) : Object.create({});
      // data.id = this.addressType;
      // data.addressType = this.addressType;
      // data.streetName = this.orgData.street_name1;
      // data.secondStreetName = this.orgData.street_name2;
      // data.postalCode = this.orgData.postnummer;
      // data.cityName = this.orgData.city;
      // this.onSubmit(this.addressType, data);

      let data = {};

      if (this.displayPostalAddress) {
        data.address_postal = {
          address_type_ids: this.addressResult1,
          street_name: this.displayPostalAddress.street_name,
          second_street_name: this.displayPostalAddress.street_name_2,
          postal_code: this.displayPostalAddress.postal,
          city: this.displayPostalAddress.city,
        };
      }

      if (this.displayBusinessAddress) {
        data.address_business = {
          address_type_ids: this.addressResult2,
          street_name: this.displayBusinessAddress.street_name,
          second_street_name: this.displayBusinessAddress.street_name_2,
          postal_code: this.displayBusinessAddress.postal,
          city: this.displayBusinessAddress.city,
        };
      }

      if (this.displayLocationAddress) {
        data.address_location = {
          address_type_ids: this.addressResult3,
          street_name: this.displayLocationAddress.street_name,
          second_street_name: this.displayLocationAddress.street_name_2,
          postal_code: this.displayLocationAddress.postal,
          city: this.displayLocationAddress.city,
        };
      }

      this.onSubmit(data);

      this.$emit('close');
    },
    
    cancel() {
      this.$emit('close');
    },

    typesUnchecked(event, result1, result2) {
      event.forEach(item => {
        let index = result1.indexOf(item);
        if (index >= 0) result1.splice(index, 1);

        index = result2.indexOf(item);
        if (index >= 0) result2.splice(index, 1);
      });
    },

    addressEvent1(event) {
      this.typesUnchecked(event, this.addressResult2, this.addressResult3); 
    },

    addressEvent2(event) {
      this.typesUnchecked(event, this.addressResult1, this.addressResult3); 
    },

    addressEvent3(event) {
      this.typesUnchecked(event, this.addressResult1, this.addressResult2); 
    },
  },

  created() {
    this.addresses['postalAddress'] = this.orgData.postalAddress;
    this.addresses['businessAddress'] = this.orgData.businessAddress;
    this.addresses['locationAddress'] = this.orgData.locationAddress
    if (this.addresses.postalAddress) {
      this.thirdPartyAddress = 'postalAddress';
    } else if (this.addresses.businessAddress) {
      this.thirdPartyAddress = 'businessAddress';
    } else if (this.addresses.locationAddress) {
      this.thirdPartyAddress = 'locationAddress';
    }

    // this.addressType = [1],
    // console.log(this.addressTypes);
  },

  props: {
    orgNumberInput: {
      type: String,
      required: true,
    },
    /**
     * Address types array
     */
    addressTypes: {
      type: Array,
      required: true,
    },
    /**
     * Address types array
     */
    orgData: {
      type: Object,
      required: true,
    },

    onSubmit: {
      type: Function,
      required: true,
      default: () => {},
    },
  },

  mixins: [
    stringFormatMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/clientAddressBrreg/clientAddressBrreg.js